<template>
  <!-- eslint-disable vue/no-v-html -->
  <div
    class="quote"
    :style="backgroundStyles"
  >
    <blockquote class="quote__quote" @click="handleLinkClick" v-html="quoteText" />
  </div>
</template>

<script>

import handleLinkClick from '@/mixins/handle-link-click-mixin';

export default {
  name: 'QuoteComponent',
  mixins: [handleLinkClick],
  props: {
    quoteBackgroundColor: {
      type: String,
      default: '',
    },
    quoteText: {
      type: String,
      default: '',
    },
    quoteBackgroundImage: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    backgroundImage() {
      if (
        !this.quoteBackgroundImage.featuredMedia
        || !this.quoteBackgroundImage.featuredMedia[0]
      ) return null;

      return `url(${this.quoteBackgroundImage.featuredMedia[0].url})`;
    },
    backgroundStyles() {
      return {
        backgroundColor: this.quoteBackgroundColor,
        backgroundImage: this.backgroundImage,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_quote';
</style>

<docs>
</docs>
